import { useMutation } from 'react-query';
import { createRegisterResultReview } from 'apis/registerResult.api';

const useCreateRegisterResultReviews = () => {
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: createRegisterResultReview,
  });
  return { mutateAsync, ...rest };
};

export default useCreateRegisterResultReviews;
